import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { BrandMarquee } from "@/components/BrandMarquee";
import { Impact } from "@/components/Impact";
import { Services } from "@/components/Services";
import { SignatureOffer } from "@/components/SignatureOffer";
import { Ventures } from "@/components/Ventures";
import { CaseStudies } from "@/components/CaseStudies";
import { Markets } from "@/components/Markets";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { Scheduler } from "@/components/Scheduler";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App grain relative bg-charcoal-900 min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <Stats />
          <BrandMarquee />
          <Impact />
          <Services />
          <SignatureOffer />
          <Ventures />
          <CaseStudies />
          <Markets />
          <About />
          <Testimonials />
          <Scheduler />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: { background: "#141416", border: "1px solid rgba(212,175,55,0.3)", color: "#F8F5EE" },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
